import { BREAKPOINT_L, BREAKPOINT_M, BREAKPOINT_XL } from '../config/'
export { Cache } from './cache'
export { Queue } from './queue'

export function addEventListener(
    event: string,
    listener: EventListenerOrEventListenerObject
): void {
    window.addEventListener(event, listener)
}

export function removeEventListener(
    event: string,
    listener: EventListenerOrEventListenerObject
): void {
    window.removeEventListener(event, listener)
}

export function getBreakpoint(): 'mobile' | 'tablet' | 'desktop' | 'retina' {
    const vw = window.innerWidth
    switch (true) {
        case vw < BREAKPOINT_M:
            return 'mobile'
        case vw < BREAKPOINT_L:
            return 'tablet'
        case vw < BREAKPOINT_XL:
            return 'desktop'
        default:
            return 'retina'
    }
}
